import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Link, useSearchParams } from "react-router";

const ChatTypeHeader = () => {
    const [searchParams] = useSearchParams();

    const type = searchParams.get("type");
    return (
        <Card className="border bg-gray-200 shadow-none">
            <div className="flex w-full  max-w-[calc(100vw-70px)] gap-3 overflow-x-auto p-1  md:overflow-x-hidden">
                <Link
                    to="/app/conversations?type=all"
                    className={cn(
                        type === "all" && "bg-white shadow-md border",
                        "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                    )}
                >
                    All
                </Link>
                <Link
                    to="/app/conversations?type=active"
                    className={cn(
                        type === "active" && "bg-white shadow-md border",
                        "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                    )}
                >
                    Active
                </Link>
                <Link
                    to="/app/conversations?type=liked"
                    className={cn(
                        type === "liked" && "bg-white shadow-md border",
                        "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                    )}
                >
                    Liked
                </Link>
                <Link
                    to="/app/conversations?type=disliked"
                    className={cn(
                        type === "disliked" && "bg-white shadow-md border",
                        "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                    )}
                >
                    Disliked
                </Link>
                <Link
                    to="/app/conversations?type=agent-chat"
                    className={cn(
                        type === "agent-chat" && "bg-white shadow-md border",
                        "rounded-lg px-4 py-2 font-semibold text-gray-600 hover:bg-white text-nowrap"
                    )}
                >
                    Agent Chat
                </Link>
            </div>
        </Card>
    );
};

export default ChatTypeHeader;
